import React from 'react'

import ModalAlert from '../../../../ui/Modals/ModalAlert'

function ModalError (props) {
  return (
    <ModalAlert
      dataCy='modal-login-error'
      type='error'
      active={props.active}
      title={props.title || 'Mensagem de erro!'}
      description={props.description || 'Desculpe, ocorreu um erro. Tente novamente mais tarde'}
      textButton='Confirmar'
      onClick={props.onClick}
    />
  )
}

export default ModalError
